import React, { FunctionComponent, useState } from 'react';
import { makeStyles, createStyles, Box, Grid } from '@material-ui/core';
import Loader from '../../../../components/Loader';
import { Inspection, CommentList, Comment } from '../../../../store/modules/application/types';
import AddCommentField from '../../../../components/AddCommentField';
import EmptyRecord from '../../../../components/TableView/TableEmptyState';
import CommentInfiniteScroll from '../../../../components/CommentInfiniteScroll';

type InspectionCommentProps = {
    addInspectionComment: Function;
    loading: Boolean;
    inspectionDetails: Inspection;
    inspectionCommentList: CommentList;
    hasMore: boolean;
    skip: number;
    setSkip: Function;
    doShowDetail: boolean;
};

const InspectionComment: FunctionComponent<InspectionCommentProps> = (props) => {
    const {
        addInspectionComment,
        loading,
        inspectionDetails,
        inspectionCommentList,
        hasMore,
        skip,
        setSkip,
        doShowDetail,
    } = props;

    const useStyles = makeStyles(() =>
        createStyles({
            addInspectionCommentDialog: {
                display: 'flex',
                flexGrow: 1,
                background: '#ffffff',
                width: '75%',
                padding: '25px',
                borderRadius: '5px',
                boxShadow:
                    '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
                marginLeft: 'auto',
                marginRight: 'auto',
                height: '100%',
                overflow: 'hidden',
            },
            comments: {
                width: '100%',
                marginTop: '40px',
            },
        }),
    );
    //@ts-ignore
    const classes = useStyles();
    const [isAddInspectionCommentOpen, setAddInspectionCommentOpen] = useState<boolean>(false);
    const [comment, setComment] = useState<string>('');
    const handleChangeComment = (event: React.ChangeEvent<{ name?: string; value: string }>) => {
        setComment(event.target.value);
    };

    const handleAddInspectionCommentChange = () => {
        addInspectionComment(comment, inspectionDetails?.id);
        setComment('');
        setAddInspectionCommentOpen(false);
    };

    const loadMore = () => {
        if (hasMore) {
            setSkip(skip + 1);
        }
    };

    const sortedList = (a: Comment, b: Comment) => {
        const date1 = new Date(b.timestamp).valueOf();
        const date2 = new Date(a.timestamp).valueOf();
        return date1 - date2;
    };

    const sortedInspectionCommentList = inspectionCommentList.sort((a: Comment, b: Comment) => {
        return sortedList(a, b);
    });

    if (loading) {
        return <Loader />;
    }
    return (
        <Box className={classes.addInspectionCommentDialog}>
            <Grid container className="verticalFillContainer">
                <AddCommentField
                    isAddCommentFieldOpen={isAddInspectionCommentOpen}
                    setAddCommentFieldOpen={setAddInspectionCommentOpen}
                    setComment={setComment}
                    handleAddCommentChange={handleAddInspectionCommentChange}
                    handleChangeComment={handleChangeComment}
                    disabled={!!comment ? false : true}
                />
                <Box className={`${classes.comments} verticalFillContent`}>
                    {sortedInspectionCommentList && sortedInspectionCommentList.length > 0 ? (
                        <CommentInfiniteScroll
                            loadMore={loadMore}
                            hasMore={hasMore}
                            data={sortedInspectionCommentList}
                            scrollableTarget="inspectionComment"
                            doShowDetail={doShowDetail}
                        />
                    ) : (
                        <Box>
                            <EmptyRecord title="No active records for this license. " message=" " />
                        </Box>
                    )}
                </Box>
            </Grid>
        </Box>
    );
};

export default InspectionComment;
